module.exports = __webpack_public_path__ + "img/chs_ch_archaon_0.d459b617.png";